(function () {
  // Mueve el boton "Calcular mi talla" de Kiwi para que quede AL LADO de las tallas.
  function moveKiwiButton() {
    var kiwiBtn = document.querySelector('button.ks-calculator-modal-button, button.sizing-calculator-modal-button');
    if (!kiwiBtn) { return false; }

    var fieldsets = document.querySelectorAll('fieldset.variant-picker__option');
    var sizeFieldset = null;
    fieldsets.forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var text = ((legend && legend.textContent) || '').toLowerCase();
      if (text.indexOf('talla') !== -1 || text.indexOf('size') !== -1) { sizeFieldset = fs; }
    });
    if (!sizeFieldset) { return false; }

    var values = sizeFieldset.querySelector('.variant-picker__option-values');
    if (!values) { return false; }

    // Colocar el boton junto a las tallas (si no esta ya ahi)
    if (!values.contains(kiwiBtn)) {
      values.appendChild(kiwiBtn);
    }
    return true;
  }

  function run() {
    moveKiwiButton();

    // Observador: reacciona apenas Kiwi inyecte el boton, aunque tarde,
    // y tambien si se vuelve a inyectar al cambiar de color/variante.
    var obs = new MutationObserver(function () { moveKiwiButton(); });
    obs.observe(document.body, { childList: true, subtree: true });

    // Reintentos de respaldo durante los primeros 20 segundos.
    var n = 0;
    var iv = setInterval(function () {
      moveKiwiButton();
      if (++n > 40) { clearInterval(iv); }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
